(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-ingredients"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const toggle = document.querySelector('.view-all-button');
    const expander = document.querySelector('.expander');

    if (toggle && expander) {
      toggle.onclick = () => {
        expander.classList.toggle('expanded');
        toggle.classList.toggle('expanded');
      };
    }
  });

  } catch(e) { console.error(e); }
})();
})();
